import React from "react";
import { Form, Button, Col, Row } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";

import TimeInput from "../../Inputs/TimeInput";

const RouteTimeShiftForm = ({ driverId, shiftStart, shiftEnd, onSubmit }) => {
  const [form] = Form.useForm();

  const handleOnFinish = values => {
    const params = {
      shiftStart: values.shiftStart,
      shiftEnd: values.shiftEnd,
    };
    onSubmit({ driver: driverId, ...params });
  };

  const handleOnChangeTimePicker = (type, value) => {
    if (type === "start") form.setFieldsValue({ shiftStart: value });
    if (type === "end") form.setFieldsValue({ shiftEnd: value });
  };

  return (
    <Form form={form} initialValues={{ shiftStart, shiftEnd }} onFinish={handleOnFinish}>
      <Row align="middle">
        <Col>
          <TimeInput
            name="shiftStart"
            required={true}
            styleInput={{ width: 50, height: 32, padding: 4, fontSize: 14 }}
            styleForm={{ margin: 0 }}
            suffixIcon={false}
            onChange={value => handleOnChangeTimePicker("start", value)}
            value={form.getFieldValue("shiftStart")}
          />
        </Col>
        <Col style={{ marginLeft: 5 }}>
          <TimeInput
            name="shiftEnd"
            required={false}
            styleInput={{ width: 50, height: 32, padding: 4, fontSize: 14 }}
            styleForm={{ margin: 0 }}
            suffixIcon={false}
            onChange={value => handleOnChangeTimePicker("end", value)}
            value={form.getFieldValue("shiftEnd")}
          />
        </Col>
        <Col style={{ marginLeft: 5 }}>
          <Button htmlType="submit" type="primary" icon={<CheckCircleOutlined />} style={{ height: 30, width: 30 }} />
        </Col>
      </Row>
    </Form>
  );
};

export default RouteTimeShiftForm;
